export default {
  AMAZON_DOMAIN: '.amazon.zinia.de',
  BNPL_DOMAIN: '.zinia.com',
  WARNING_TIME_MS: 60000,
  AUTH_GUARD_PROVIDER_PATHS: {
    CUSTOMER: ['linkup', 'customer', 'payments', 'mandate', 'login', 'credit-line']
  }
};